import React from "react"
import Header from "../components/core/header"
import Footer from "../components/core/footer"
import SEO from "../components/Features/seo"
import SocialIcons from "../components/Features/socialIcons"
import "../styles/index.scss"
import Helmet from "react-helmet"
const Contact = () => {
  return (
    <div>
      <Helmet>
        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "url": "https://www.freelancology.com",
          "name": "Freelancology Blog",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+92-344-309-0106",
            "contactType": "Customer Support"
          }
        }
      `}
        </script>
      </Helmet>
      <Header />

      <div className="bg-white container pl-4 pr-4 pb-1 pt-2  mt-5 h-100">
        <SEO title="Contact us | Freelancology" slug="contact" />
        <div className="row mt-5 h-100 justify-content-center align-items-center">
          <div className="col-md-6 pb-5 pl-3 pr-3">
            <h1 className="jazz-feed text-left">Contact Us</h1>
            <p className="text-justify">
              The Freelancology is a blog webiste that covers all sorts of News
              / Shobiz / Sports / Mobile / Packages / new Techniques and
              Technologies articles. If you have any article you can share us we
              will post on our website by your name. if you want to promote your
              business product/page etc contact us.
            </p>
            <h5>
              Address:{" "}
              <small className="text-muted">
                Latifabad Unit 2 , Hyderabad, Sindh, Pakistan
              </small>
            </h5>

            <h5>
              Email:{" "}
              <small className="text-muted">info@freelancology.com</small>
            </h5>
            <h5>
              Contact:{" "}
              <small className="text-muted">
                +923450152988 || +923443099106
              </small>
            </h5>
            <SocialIcons />
          </div>
          <div className="col-md-6 bg-white pt-5 pb-5 pl-3 pr-3">
            <form
              action="https://getform.io/f/715b34c0-bd50-4f27-a8fa-7125ace1c867"
              method="POST"
            >
              <h4 className="text-center jazz-feed">Quick Contact</h4>
              <div className="form-group">
                <input
                  name="name"
                  type="name"
                  className="form-control"
                  id="exampleInputName"
                  placeholder="Your Full Name..."
                />
              </div>
              <div className="form-group">
                <input
                  name="email"
                  type="email"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="Your Email Address..."
                />
              </div>
              <input
                type="text"
                name="subject"
                className="form-control mb-3"
                id="exampleSubject"
                placeholder="Subject..."
              />
              <div className="form-group">
                <textarea
                  name="message"
                  className="form-control"
                  aria-label="With textarea"
                  placeholder="Your Message..."
                ></textarea>
              </div>
              <button
                type="submit"
                className="btn outline btn-primary btn-lg btn-white w-100 mb-3"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Contact
